import {  LogLevel } from "@azure/msal-browser";
import { Config } from "./services/config";
export const msalConfig = {
    auth: {
        clientId: "d3a968a7-d6f0-406f-8d3c-d209cf3cba58",
        authority: "https://login.microsoftonline.com/a3e95c2e-9a60-4671-be2f-94f90325f7b9",
        redirectUri: Config.redirectUri,
        navigateToLoginRequestUrl: true,
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false,
      },
    system: {
    loggerOptions: {
        loggerCallback: (level, message) => {
            //console.log(`MSAL [${level}]: ${message}`);
        },
        logLevel: LogLevel.Verbose,
        piiLoggingEnabled: false,
    },
    },

};




export const loginRequest = {
    scopes: [
      "openid",
      "email",
      "profile",
      "User.Read",
      "User.ReadBasic.All"
    ],
    prompt: "select_account",
    account: null
  };